<div *ngIf="showRequest && model != null" class="">
  <h2 class="sectionTitle">{{'ADMIN_USER.E_TENDER_FORM.DEFINE_TENDER_DEADLINE' | translate }}</h2>
  <form [formGroup]="defineTenderDeadlineForm">
    <div class="form-container" #defineTenderDeadline>
      <!--TitleAr -->
      <div class="form-group" *ngIf="model.Language == 1 ||model.Language == 3">
        <label for="TitleAR">{{ 'ADMIN_USER.E_TENDER_FORM.TITLE_AR' | translate }}</label>
        <label class="form-control">{{model.TitleAR}}</label>
      </div>
      <!--TitleEn -->
      <div class="form-group" *ngIf="model.Language == 2 || model.Language == 3">
        <label for="TitleEN">{{ 'ADMIN_USER.E_TENDER_FORM.TITLE_EN' | translate }}</label>
        <label class="form-control">{{model.TitleEN}}</label>
      </div>
      <!--Suppliers-->
      <div class="form-group">
        <label for="msSupplier">{{ 'ADMIN_USER.E_TENDER_FORM.ETENDERS_SUPPLIERS' | translate }}</label>
        <span class="red"> *</span>
        <ng-multiselect-dropdown id="msSupplier" [formControl]="Validate['ETenderSuppliers']"
          placeholder="{{ 'ADMIN_USER.E_TENDER_FORM.ETENDERS_SUPPLIERS' | translate }}" [settings]="suppliersDropdownSettings" 
          [data]="suppliersList"
          [disabled]="false">
        </ng-multiselect-dropdown>
        <div *ngIf="submitted && Validate.ETenderSuppliers?.errors" class="red">
          <div *ngIf="Validate.ETenderSuppliers?.errors?.required">
            {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
        </div>
        <div *ngIf="suppliersList.length==0" class="red">
          {{ 'ADMIN_USER.E_TENDER_FORM.NO_QUALIFIED_SUPPLIERS' | translate }}
        </div>
      </div>
      <!--تاريخ فتح المظاريفoffer deadline-->
      <div class="form-group">
        <label for="OD">{{ 'ADMIN_USER.E_TENDER_FORM.OFFER_DEADLINE' | translate}}</label>
        <span class="red"> *</span>
        <div class="split-form-group ">
          <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="OD"
            [ngClass]="{ 'is-invalid': submitted ||(Validate.OD?.dirty  && Validate.OD?.errors) }">
          <timepicker id="ODTime" formControlName="ODTime" [hourStep]="1" [minuteStep]="1"></timepicker>
        </div>

        <div *ngIf="(Validate.OD?.dirty && Validate.OD?.errors)||(Validate.ODTime?.dirty && Validate.ODTime?.errors)"
          class="red ">
          {{'ADMIN_USER.SHARED.REQUIRED' | translate}}
        </div>
        <div *ngIf="invalidOfferDeadline" class="red ">
          {{'ADMIN_USER.E_TENDER_FORM.END_DATE_GREATER_THAN_OFFER_DEADLINE_MESSAGE' | translate}}
        </div>
      </div>
      <!--comment (textarea), ملاحظات-->
      <div class="form-group">
        <label for="DefineOfferDeadlineComments">{{ 'ADMIN_USER.E_TENDER_FORM.COMMENTS' | translate }}</label>
        <span class="red"> *</span>
        <textarea type="text" id="DefineOfferDeadlineComments" name="DefineOfferDeadlineComments" class="form-control"
          formControlName="DefineOfferDeadlineComments"></textarea>
        <div *ngIf="submitted && Validate.DefineOfferDeadlineComments?.errors" class="red ">
          <div *ngIf="Validate.DefineOfferDeadlineComments?.errors?.required">
            {{ 'ADMIN_USER.SHARED.REQUIRED' | translate }}</div>
        </div>
      </div>
      <!--attachment (upload control) , المرفقات-->
      <div class="form-group">
        <label>{{'ADMIN_USER.E_TENDER_FORM.ATTACHMENTS'|translate}}</label>
        <input type="file" class="form-control" MaxSizeInMB="50"
          accept=".pdf,.gif, .jpg, .jpeg, .png, .bmp,.doc,.docx,.rar" id="DefineOfferDeadlineAttachment"
          formControlName="DefineOfferDeadlineAttachment"
          (change)="AddAttachmentFile($event, Validate.DefineOfferDeadlineAttachment, 'CreateTender_DefineOfferDeadlineAttachment', ETenderAttachmentType.DefineOfferDeadlineAttachment, 'AttachmentProgress')" />
        <div class="upload-info">
          <span>{{'ADMIN_USER.SHARED.ETENDER_ALLOWED_FILE_EXTENSIONS' | translate}}</span>
        </div>
        <div class="progress">
          <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
            [style.width]="AttachmentProgress + '%'">
            <span class=""> {{AttachmentProgress}} % Complete</span>
          </div>
        </div>
      </div>
    </div>


    <div class="form-group">
      <button [disabled]="loading" class="btn btn-primary SCAcustomBtn" Confirmation
        (confirmationClick)="onSubmit()">{{ 'FRONT_USER.SAVE' | translate}}</button>
    </div>
  </form>
</div>
<!-- Confirmation -->
<div *ngIf="!showRequest" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p> {{ 'ADMIN_USER.E_TENDER_FORM.SUCCESS_MSG' | translate }}
    </p>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
        {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
  </div>
</div>